<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 09:27:24
 * @fileName     :
 * @Description  : 我的签约
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="合同名称" porp="contractName">
            <el-input v-model="formInline.contractName" placeholder="合同名称"></el-input>
          </el-form-item>
          <el-form-item label="客户负责人" porp="customerChargePerson">
            <el-input v-model="formInline.customerChargePerson" placeholder="客户负责人"></el-input>
          </el-form-item>
          <el-form-item label="是否归档" porp="ifArchive">
            <el-select clearable v-model="formInline.ifArchive" filterable placeholder="请选择是否归档">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" prop="customerId">
            <el-select clearable v-model="formInline.customerId" filterable placeholder="请选择客户">
              <el-option v-for="item in customerOption" :key="item.id" :label="item.customerName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-select v-model="formInline.orderBy" placeholder="请选择">
              <el-option key="1" label="创建时间-倒序" value="createTimeDesc"/>
              <el-option key="2" label="到期时间-倒序" value="endTimeDesc"/>
              <el-option key="3" label="到期时间-正序" value="endTimeAsc"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
            <el-button type="primary" @click="exportData('ruleForm')">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <el-button type="success" @click="addItem()">新增</el-button>
      <!--
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" @preSortChanges="handleSortChange" :loading="loading" :pagination="pagination">
        <template #ifArchiveSlot="{ row }">
          <div>
            <el-tag :type="row.ifArchive == 0 ? 'danger' : 'success'" effect="dark">{{ row.ifArchive == 0 ? "否" : "是"
              }}</el-tag>
          </div>
        </template>
        <template #signingTypeSlot="{ row }">
          <div>
            {{ row.signingType == 1 ? '新签' : '续签' }}
          </div>
        </template>
        <template #contractStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.contractStatus, 'contract').type" effect="dark">{{
              formatterState(row.contractStatus,'contract').text }}</el-tag>
          </div>
        </template>

        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="change(row)" v-if="row.contractStatus == 2">变更</el-button>
            <el-button type="text" @click="reAdd(row)" v-if="false">重新发起</el-button>
            <el-button type="text" @click="withdraw(row)" v-if="row.contractStatus == 1">撤销</el-button>
            <el-button type="text" @click="edit(row)"
              v-if="row.contractStatus == 3 || row.contractStatus == 0|| row.contractStatus == 9">修改</el-button>
            <el-button type="text" @click="removeItem(row)" style="color:#F56C6C;"
              v-if="row.contractStatus == 0|| row.contractStatus == 9">删除</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <my-contract-details ref="myComtractRefs" @initQueryData="queryData" :title="detailsT"
      :status="preStatus"></my-contract-details>
  </div>
</template>

<script>
import myContractDetails from './components/myContractDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { formatterState } from '@/utils/index'
import {
  queryContractReceivePaymentApi,
  deleteContractReceivePaymentApi,
  withdrawContractReceivePaymentApi, exportForMy
} from '@/api/receivableContract‌/index'
import { querySupplierInfoListApi } from '@/api/basicInfo/index'
import {downloadBlobFile} from "@/utils/common";
export default {
  components: {
    tableComponent,
    myContractDetails
  },
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      detailsT: '我的签约详情',
      formInline: {
        contractName: "",
        customerChargePerson: "",
        ifArchive: "",
        customerId: "",
        orderBy: "createTimeDesc",
      },
      customerOption: [],
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "180px",
          keyName: "contractName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "项目类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "projectTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "合同金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 21,
          title: "已开票", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "invoicedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 23,
          title: "已收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "receivedAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 113,
          title: "电费收款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "electricityCollectionAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 114,
          title: "电费付款", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "electricityPaymentAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "260px",
          keyName: "customerName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "客户负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "customerChargePerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "我方单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "240px",
          keyName: "ownerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "我方负责人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "ownerChargePersonName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 101,
          title: "到期日期", // 标题名称
          isSort: true, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "endDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "合同期限（天）", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractDuration", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "签约类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "60px",
          keyName: "signingType", // 数据的属性值
          align: "center",
          slotName: "signingTypeSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "签约日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "signingDate", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "合同状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "contractStatus", // 数据的属性值
          align: "center",
          slotName: "contractStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 12,
          title: "是否归档", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "ifArchive", // 数据的属性值
          align: "center",
          slotName: "ifArchiveSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 13,
          title: "归档时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "archiveTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 14,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "145px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "操作", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          fixed: "right",
          width: "200px",
          keyName: "", // 数据的属性值
          align: "center",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    let routeQuery = this.$route.query;
    if ('contractName' in routeQuery) {
      this.formInline.contractName = routeQuery.contractName;
    }
    this.getCustomerList()
    this.queryData()
  },
  methods: {
    formatterState,
    //获取客户列表
    getCustomerList() {
      querySupplierInfoListApi({ customerName: "" }).then(res => {
        if (res.code == 200) {
          this.customerOption = res.data || []
        }
      })
    },
    //查询
    queryData() {
      this.initData()
    },
    //到期日期排序
    handleSortChange(item) {
      if (item.sortState === 'asc') {
        this.formInline.orderBy = 'endTimeAsc'
      } else if (item.sortState === 'desc') {
        this.formInline.orderBy = 'endTimeDesc'
      }
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            contractName: this.formInline.contractName,
            customerChargePerson: this.formInline.customerChargePerson,
            orderBy: this.formInline.orderBy,
          },
          signingType: "",//签约类型：1 新签 2 续签
          customerId: this.formInline.customerId,//客户ID
          ownerId: "", //我方单位ID
          ifArchive: this.formInline.ifArchive,
        },
        ...item
      }
      this.loading = true;
      queryContractReceivePaymentApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.contractName = "";
      this.formInline.customerChargePerson = "";
      this.formInline.ifArchive = "";
      this.formInline.customerId = "";
      this.$nextTick(() => {
        this.initData()
      })

    },
    addItem() {
      this.preStatus = 'add'
      this.detailsT = '我的签约新增'
      this.$refs.myComtractRefs.openDrawer({})
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '我的签约详情'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    change(row) {
      this.preStatus = 'change'
      this.detailsT = '我的签约变更'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    reAdd(row) {
      this.preStatus = 'reAdd'
      this.detailsT = '我的签约重新发起'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    edit(row) {
      this.preStatus = 'edit'
      this.detailsT = '我的签约编辑'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    renewal(row){
      this.preStatus = 'renewal'
      this.detailsT = '我的签约续签'
      this.$refs.myComtractRefs.openDrawer(row)
    },

    removeItem(row) {
      this.$confirm('确定要删除该合同？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        deleteContractReceivePaymentApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    withdraw(row) {
      this.$confirm('确定要撤销该合同？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        withdrawContractReceivePaymentApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    exportData(item = {}){
      let params = {
        params: {
          contractName: this.formInline.contractName,
          customerChargePerson: this.formInline.customerChargePerson,
          orderBy: this.formInline.orderBy,
        },
        signingType: "",//签约类型：1 新签 2 续签
        customerId: "",//客户ID
        ownerId: "", //我方单位ID
        ifArchive: this.formInline.ifArchive,
        ...item
      }
      exportForMy(params).then(res => {
        if(res){
          downloadBlobFile(res,'合同列表.xlsx');
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
